import styled from '@emotion/styled/macro';

const DrawerContent = styled('div')`
  padding: 0 1.5rem;
  margin: 1rem 0;
`;

export default DrawerContent;
